'use client'

import Script from 'next/script'

interface GoogleAnalyticsProps {
  gaId?: string
  gtagId?: string
  googleAdsId?: string
  googleAdsConversionId?: string
}

export function GoogleAnalytics({
  gaId,
  gtagId,
  googleAdsId,
  googleAdsConversionId
}: GoogleAnalyticsProps) {
  const measurementId = gaId || gtagId

  if (!measurementId) {
    return null
  }

  return (
    <>
      {/* Google Tag Manager / Analytics */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            // Enable debug mode for localhost
            const isLocalhost = window.location.hostname === 'localhost' ||
                               window.location.hostname === '127.0.0.1';

            gtag('config', '${measurementId}', {
              page_path: window.location.pathname,
              debug_mode: isLocalhost,
              cookie_domain: 'auto',
              send_page_view: true
            });
            ${googleAdsId ? `gtag('config', '${googleAdsId}');` : ''}
            ${googleAdsConversionId ? `gtag('config', '${googleAdsConversionId}');` : ''}
          `,
        }}
      />
    </>
  )
}